import React from 'react';
import classess from  './VerificationStep.scss';
import { getLocalizedStrings } from '../../mfaPageLocalizedStrings';
import classes from '../../../../CPCGuest/GuestBPSearch/guestBPSearch.scss';
import LoadIndicator from '../../../../../Common/CommonComponents/LoadingIndicator/loadingIndicator';

const VerificationStep = (props) => {
  const {
    phoneNumber = 'ab000',
    verificatonCode,
    handleVerificatonCodeChange,
    handleCancel,
    handleVerifyCode,
    handleMethodChange,
    handleResend,
    showError,
    receiveCodeVia,
    userLoginInfoDetails,
    fromPayment,
    noPhoneNumberPresent,
    onEnterKeyPress,
    verifyErrMsg,
    verifyErrorCode,
    showLoader
  } = props;

  const lastFourDigits = phoneNumber.toString().slice(-4);
  const maskedEmailId = userLoginInfoDetails ? userLoginInfoDetails.emailId ? userLoginInfoDetails.emailId.split('@')[0].slice(0, 2) + '****' + userLoginInfoDetails.emailId.split('@')[0].slice(-3) + '@' + userLoginInfoDetails.emailId.split('@')[1] : '' : '';
  const strings = getLocalizedStrings('TurnOnMFA');
  const VerifyOpacity = (verifyErrorCode === 'OKTA_E0000069' || verifyErrorCode === 'OKTA_E0000047') ? classess.verifyDisable : '';

  if(showLoader){
    return <LoadIndicator showLoading />;
  }

  return (
    <div>
      <h3 className={classess.codeSendHeading}>{receiveCodeVia === 'email' ? `${strings.verifyEmailHeading} ${maskedEmailId}` : `${strings.verificationHeading} ${lastFourDigits}`}</h3>
      <br />
      <div className={classess.modalActions}>
        <label><p className={classess.enterCodeLabel}>{strings.enterCode}</p>
          <input
            type='text'
            placeholder='Enter Code'
            maxLength={6}
            className={classess.mfaPhoneNumber}
            value={verificatonCode}
            onChange={handleVerificatonCodeChange}
          />
        </label>
        <button className={classess.mfaSendCode + ' ' + VerifyOpacity} disabled={(verifyErrorCode === 'OKTA_E0000069' || verifyErrorCode === 'OKTA_E0000047') ? true : false} onClick={handleVerifyCode} >{strings.verifyButton}</button>
        <button className={classess.mfaCancel} onClick={handleCancel}>{strings.cancel}</button>
      </div>
      { showError === true &&<div className={classes.searchError + ' ' + classess.mfaError} >{verifyErrMsg}</div>}
      <p>{strings.anotherCode}</p>
      <div onClick={handleResend} onKeyDown={(event) => onEnterKeyPress(event,handleResend)} tabIndex={0} className={`${classess.linkColor} ${classess.textUnderlineCursor} ${classess.resendSpace} ${VerifyOpacity}`}>{strings.resend} </div>
      { !(fromPayment && noPhoneNumberPresent) && <div onClick={handleMethodChange} onKeyDown={(event) => onEnterKeyPress(event,handleMethodChange)} tabIndex={0} className={`${classess.linkColor} ${classess.textUnderlineCursor} ${VerifyOpacity}`} >{strings.differentMethod}</div>}

    </div>
  );
};

export default VerificationStep;